
import React from "react";
import { Lock } from "lucide-react";
import { ResourceFile } from "./types";
import { StatusBadge } from "./sidebar/StatusBadge";
import { FileItemTooltip } from "./sidebar/FileItemTooltip";

interface SidebarFileItemProps {
  file: ResourceFile;
  index: number;
  currentFileIndex: number;
  isLocked: boolean;
  isCompleted: boolean;
  isTrainee: boolean;
  isAdmin: boolean;
  onFileSelect: (index: number) => void;
}

export function SidebarFileItem({
  file,
  index,
  currentFileIndex,
  isLocked,
  isCompleted,
  isTrainee,
  isAdmin,
  onFileSelect
}: SidebarFileItemProps) {
  return (
    <FileItemTooltip isLocked={isLocked}>
      <div>
        <button
          onClick={() => onFileSelect(index)}
          className={`w-full text-left p-2 rounded-lg transition-colors ${
            currentFileIndex === index 
              ? 'bg-[#8B5CF6] text-white' 
              : isLocked 
                ? 'bg-gray-100 text-gray-400 cursor-not-allowed' 
                : 'hover:bg-[#E5DEFF]'
          }`}
          disabled={isLocked}
        >
          <div className="flex flex-col space-y-1">
            <div className="font-medium flex items-center">
              {isLocked && <Lock className="h-3 w-3 mr-1.5 opacity-70" />}
              {file.title}
            </div>
            {file.description && (
              <div className="text-sm opacity-80">{file.description}</div>
            )}
            {isTrainee && !isAdmin && (
              <div className="flex justify-start mt-1">
                <StatusBadge isCompleted={isCompleted} />
              </div>
            )}
          </div>
        </button>
      </div>
    </FileItemTooltip>
  );
}
